$(document).ready(function(e){
$(".tab-container .tab_content").hide();
        $('.tab-container').each(function (k, v) {
            $(v).find('.tab_content:first').show();
        });

        /* if in tab mode */
        $("ul.tabs li").click(function () {
            var parent = $(this).parents('.tab-container');

            $(parent).find(".tab_content").hide();
            var activeTab = $(this).attr("rel");
            $(parent).find("#" + activeTab).fadeIn();

            $(parent).find("ul.tabs li").removeClass("active");
            $(this).addClass("active");

            $(parent).find(".tab_drawer_heading").removeClass("d_active");
            $(parent).find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
            $('.product-list').slick('refresh');

        });


$('.video_block').slick({
            infinite: false,
            speed: 300,
            dots:true,
            arrows:false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

  
  

// $("ul.tabs li").click(function(){
//   $('.products-list').slick('refresh');
// });

  
  });    

document.addEventListener('DOMContentLoaded', function () {
  $('.product-list-slider').each(function() {
    var $slider = $(this);
    // Count how many products actually rendered
    var slideCount = $slider.children('.product_col').length;

    // Only initialize if there is at least 1 product
    if (slideCount > 0) {
      $slider.slick({
        // Dynamically toggle infinite based on slide count to prevent the 1px collapse bug
        infinite: slideCount > 5, 
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,  
        swipeToSlide: true, 
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              swipeToSlide: true,
              infinite: slideCount > 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              swipeToSlide: true,
              infinite: slideCount > 3
            }
          },
          {
            breakpoint: 769, 
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              swipeToSlide: true,
              infinite: slideCount > 2
            }
          },
          {
            breakpoint: 480,
            settings: "unslick" // Kills the JS slider on mobile for your CSS flex snap
          }
        ]
      });
    }
  });
});